<template>
  <div>
    <div v-if="cargando" class="cargando">
            <v-progress-circular
            indeterminate
            color="#2562a4"
          ></v-progress-circular>
    </div>
    <div v-else id="informes" class="w-100">
      <v-toolbar class="sub-toolbar" flat>
        <v-btn  flat class="primary-color" @click="dialog = true">
          <v-icon class="mr-2">description</v-icon>
          Seleccionar Informe
        </v-btn>
      </v-toolbar>
      <div class="w-100 pt-5">
        <etiquetas v-if="informeSelec.code === 'etiquetas'" />
      </div>
      <v-dialog
        v-model="dialog"
        max-width="500"
        class="no-flex"
      > 
        <div style="min-height: 300px;" class="scan-dialog">
          <v-toolbar flat class="d-flex justify-space-between ">
            <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">description</v-icon>Seleccionar informe</v-toolbar-title>
              <v-btn 
                icon
                flat
                class="primary-color"
                @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="pa-4">
              <vue-select class="select-search w-100" :options="informes" label="label" v-model="informeSelec" :clearable="false" @input="cambioInforme()"></vue-select>
            </div>
            <!-- <v-btn @click='dialog = false'
                :disabled="informeSelec ===''"
                flat
                fab
                absolute
                bottom
                right
                dark
                class="orange guardar">
            <v-icon>check</v-icon>
            </v-btn> -->
        </div>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import etiquetas from './informes/Etiquetas.vue'
export default {
  components: { etiquetas },
  data() {
    return {
      cargando: false,
      dialog: true,
      informes: [{label: 'Etiquetas', code: 'etiquetas'}],
      informeSelec: ''
    }
  },
  created() {
    this.cambioTitulo()
  },
  methods: {
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">description</v-icon>`
      this.$store.state.titulo = "Informes"
    },
    cambioInforme(){
      this.dialog = false
    }
  },
}
</script>